export default __webpack_public_path__ + "static/MinisterioDeCiencia-33b1769159e9d845db4be5603cf8d08a.svg";